export function isNativeAgentReadyForWorkspace(
  conversationId: string | null,
  conversationWorkspaceRoot: string | null,
  workspaceRoot: string | null,
): boolean {
  return conversationId !== null && conversationWorkspaceRoot === workspaceRoot;
}
